import dataUtil from '@/utils/data'

export default {
    methods: {
        ...dataUtil
    }
}